import { Store } from './store';
import {
  setUserLoggedLoaded,
  LogOutAction,
} from '../layout/redux/layoutActions';

const fillSessionStorage =
  !sessionStorage.length || sessionStorage.length === 1;

export const getSessionStorage = () => {
  if (fillSessionStorage) {
    localStorage.setItem('getSessionStorage', String(Date.now()));
  }
};

export const flushUserCredentials = () => {
  localStorage.setItem('flushCredentials', String(Date.now()));
  localStorage.removeItem('flushCredentials');
};

export const acceptTermsOfUse = () => {
  localStorage.setItem('terms_of_use', JSON.stringify({ accept: true }));
  localStorage.removeItem('terms_of_use');
};

export const saveUser = (userId) => {
  if (userId) {
    Store.dispatch(setUserLoggedLoaded({ user_id: userId }));
  }
};

export const shareSessioStorageBetweenTabs = () => {
  getSessionStorage();

  window.addEventListener('storage', function (event) {
    if (event.key === 'getSessionStorage') {
      localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
      localStorage.removeItem('sessionStorage');
      localStorage.removeItem('getSessionStorage');
    }
    if (event.key === 'sessionStorage' && fillSessionStorage) {
      const data = event.newValue ? JSON.parse(event.newValue) : [];
      for (const key in data) {
        sessionStorage.setItem(key, data[key]);
      }
      saveUser(data.user_id);
    }
    if (event.key === 'flushCredentials') {
      Store.dispatch(LogOutAction());
    }
    if (event.key === 'terms_of_use' && JSON.parse(event.newValue).accept) {
      sessionStorage.setItem('terms_of_use', event.newValue);
      window.location.reload(false);
    }
  });
};
